
import {
  CardContent
} from "@/components/ui/card";

interface ProfilePhotoCardProps {
  profilePhotoUrl: string | undefined;
}

export function ProfilePhotoCard({ 
  profilePhotoUrl
}: ProfilePhotoCardProps) {

  return (
   
      <CardContent className="grid gap-4">
        {profilePhotoUrl && (
          <img
            src={profilePhotoUrl}
            alt="Profile"
            className="rounded-full w-24 h-24 object-cover"
          />
        )}
       
      </CardContent>
   
  );
}
